import * as Sentry from '@sentry/browser'

let isInitialized = false

/**
 * Initialize Sentry for error tracking
 * Should be called once at app startup
 */
export function initSentry(dsn: string | undefined) {
  if (isInitialized || !dsn) {
    return
  }

  Sentry.init({
    dsn,
    release: `phonesalad-frontend@${import.meta.env.VITE_APP_VERSION || 'unknown'}`,
    integrations: [],
    tracesSampleRate: 0,
  })

  isInitialized = true
}

/**
 * Check if Sentry is initialized
 */
export function isSentryInitialized(): boolean {
  return isInitialized
}

/**
 * Export Sentry for use in error reporting
 */
export { Sentry }
